export const INSTAGRAM_LINK = 'https://www.instagram.com/contaldi_lit_it_electric?igsh=bTRkemphN2RjZjVw';
